"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.XFilledCircleIcon = void 0;
var react_1 = __importDefault(require("react"));
var cn_1 = require("../../../utils/cn");
var cls = (0, cn_1.classNames)('twitter-filled-circle-icon');
var XFilledCircleIcon = function (_a) {
  var className = _a.className;
  return react_1.default.createElement("svg", {
    className: cls.name(className),
    width: "16",
    height: "16",
    viewBox: "0 0 96 96"
  }, react_1.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 96C74.5097 96 96 74.5097 96 48C96 21.4903 74.5097 0 48 0C21.4903 0 0 21.4903 0 48C0 74.5097 21.4903 96 48 96ZM42.7608 50.2685L24.6146 26.0054H38.6003L50.4966 41.9119L65.22 26.0054H69.3298L52.3328 44.3676L71.5 69.9955H57.5143L44.597 52.7242L28.6098 69.9955H24.5L42.7608 50.2685ZM37.0834 29.0326H30.6583L59.0303 66.9677H65.4553L37.0834 29.0326Z"
  }));
};
exports.XFilledCircleIcon = XFilledCircleIcon;